import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { map, tap } from "rxjs/operators";

import { CacheDataSource } from "./cache.datasource";
import { ENVIRONMENT } from "../../core/token";

@Injectable()
export class ProductsDataSource extends CacheDataSource {
	constructor(@Inject(ENVIRONMENT) protected environment, httpClient: HttpClient) {
		super(httpClient);
		this.setPath(environment.api_url + "/v2/products");
	}

	public set(id: any, value?: any) {
		if (value) {
			this.cache.set(id, value);
			return;
		}
		const aux = this.cache.get(id);
		if (aux) {
			return;
		}
		this.cache.set(id, "pending");

		if (id != "?limit=100") this.setQuery("?appId=" + id);

		const subscription: Subscription = this.getDataAsObservable()
			.pipe(
				map((result) => {
					if (result["error_api-error"]) throw new Error(result["error_api-error"]["http_body"]);
					else return result.data[0];
				}),
				tap((el) => this.cache.set(id, el)),
			)
			.subscribe((res) => subscription.unsubscribe());

		this.setQuery("");
	}

	public setBulk(ids: Array<string>) {
		ids = ids.filter((value, index, self) => self.indexOf(value) === index);
		let query = "";
		const filtered = ids.filter((el) => el !== undefined && this.get(el) === undefined);
		if (filtered.length === 0) {
			return;
		}
		filtered.forEach((id, index) => {
			let pre = "&";
			if (index == 0) {
				pre = "?";
			}
			query += pre + "appId=" + id;
			this.cache.set(id, "pending");
		});
		this.setQuery(query);
		const subscription: Subscription = this.getDataAsObservable()
			.pipe(
				tap((result) => {
					result?.data.forEach((element: any) => {
						this.set(element.subscriptionId, element);
					});
				}),
			)
			.subscribe((res) => subscription.unsubscribe());

		this.setQuery("");
	}
}
